import React from "react";
import * as RadixPopover from "@radix-ui/react-popover";
import "./Popover.css";

export const Popover = RadixPopover.Root;
export const PopoverTrigger = RadixPopover.Trigger;
export const PopoverClose = RadixPopover.Close;
export const PopoverAnchor = RadixPopover.Anchor;

export function PopoverContent({
  side = "bottom",
  align = "start",
  sideOffset = 6,
  className = "",
  children,
  ...props
}) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={`ui-popover ${className}`}
        {...props}
      >
        {children}
      </RadixPopover.Content>
    </RadixPopover.Portal>
  );
}
